import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Modal from "../../../components/Modal";
import Button from "../../../components/Button";
import Icon from "../../../components/Icon";

import api from "../../../services/api";
import { renderError } from "../../../helpers/errors";
import { parseBlobError, reportFileName } from "../helpers";

/**
 * Exportação do relatório (BDM-1040). Excel e só: sem escolha de formato e sem
 * envio por e-mail. A única decisão que sobra é o escopo — e ela importa,
 * porque o resumo agrupado e os lançamentos por trás dele são planilhas
 * completamente diferentes.
 *
 * O download vai por blob: o endpoint exige token no header, então apontar o
 * navegador para a URL não autenticaria.
 */
export const ModalExport = ({ show, close, name, dataset, config, result }) => {
    const [saving, setSaving] = useState(false);
    const [detailed, setDetailed] = useState(false);

    const grouped = !!result?.grouped;
    const rowCount = result?.rows?.length ?? 0;

    useEffect(() => {
        if (show) setDetailed(false);
    }, [show]);

    const exportExcel = () => {
        setSaving(true);

        // Exportar detalhado é o mesmo relatório sem o agrupamento: cada
        // lançamento vira uma linha, com as mesmas colunas e filtros.
        const exportConfig = detailed ? { ...config, group_by: [] } : config;

        api.post(`/report/export`, { dataset, name, config: exportConfig }, { responseType: 'blob' })
            .then(res => {
                const url = window.URL.createObjectURL(res.data);
                const link = document.createElement('a');

                link.href = url;
                link.download = reportFileName(name);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);

                toast.success('Arquivo gerado');
                close();
            })
            .catch(async error => renderError(await parseBlobError(error)))
            .then(() => setSaving(false));
    };

    return (
        <Modal
            title={`Exportar relatório`}
            show={show}
            close={close}
            footer={
                <>
                    <Button type={`secondary`} size={`small`} text={`Cancelar`} action={close} />
                    <Button type={`primary`} size={`small`} text={`Baixar Excel`} action={exportExcel} loading={saving} />
                </>
            }
        >
            <div className="section">
                <div className="report-export-file">
                    <Icon name="table" size={26} />
                    <div>
                        <strong>{reportFileName(name)}</strong>
                        <span>Uma aba com as colunas do relatório e a linha de totais.</span>
                    </div>
                </div>

                {grouped &&
                    <div className="report-export-scope">
                        <label>Linhas</label>
                        <button type="button" className={`scope-option${detailed ? '' : ' active'}`} onClick={() => setDetailed(false)}>
                            <span className="radio" />
                            O resumo agrupado ({rowCount} {rowCount === 1 ? 'linha' : 'linhas'})
                        </button>
                        <button type="button" className={`scope-option${detailed ? ' active' : ''}`} onClick={() => setDetailed(true)}>
                            <span className="radio" />
                            Os lançamentos por trás dele
                        </button>
                    </div>
                }

                <div className="box-alert-info">
                    Relatórios muito grandes saem cortados: a planilha leva até 50 mil linhas.
                </div>
            </div>
        </Modal>
    );
};

export default ModalExport;
